import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, TrendingUp } from 'lucide-react';

export function TopPerformers() {
  const performers = [
    {
      name: 'Emma Wilson',
      progress: 92,
      improvement: '+15%',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&q=80'
    },
    {
      name: 'Mike Johnson',
      progress: 88,
      improvement: '+12%',
      image: 'https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=100&h=100&fit=crop&q=80'
    },
    {
      name: 'Sarah Chen',
      progress: 85,
      improvement: '+10%',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&q=80'
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center gap-3 mb-6">
        <Trophy className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Top Performers</h2>
      </div>

      <div className="space-y-4">
        {performers.map((performer, index) => (
          <motion.div
            key={performer.name}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className="flex items-center gap-4"
          >
            <img
              src={performer.image}
              alt={performer.name}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="flex-1">
              <div className="font-medium">{performer.name}</div>
              <div className="flex items-center gap-1 text-xs text-success">
                <TrendingUp className="w-3 h-3" />
                <span>{performer.improvement}</span>
              </div>
            </div>
            <div className="text-right">
              <div className="font-bold">{performer.progress}%</div>
              <div className="text-xs text-muted-foreground">progress</div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}